<form [formGroup]="form" class="flex w-full flex-col gap-(--gap-relaxed)">
  @if (t.testMode()) {
    <div class="text-bold">
      {{ 'entities.choiceList.labels.listInUse' | transloco }}:
      {{ isListUsed() ? ('common.buttons.yes' | transloco) : ('common.buttons.no' | transloco) }}
    </div>
  }
  <div class="content overflow-y-auto p-(--space-1) scrollbar-thin max-h-6/10 flex flex-col gap-(--gap-relaxed) mb-(--space-4)">
    <div class="flex flex-col gap-(--gap-loose)">
      <ces-text-field
        formControlName="name"
        [config]="fieldConfig('name')"
        [label]="fieldConfig('name')?.label"
        [externalErrors]="getExternalErrorsForField('name')" />

      <app-choice-list-elements-editor
        [parentId]="entity?.id"
        [elements]="elements"
        [isUsed]="isListUsed()"
        [originalElements]="originalElements"
        (elementsChange)="onElementsChange($event)"
        (validityChange)="onElementsValidityChange($event)"
        #elementsEditor />

      @if (errorMessage) {
        <div class="text-red-500 mb-(--space-3)">
          {{ errorMessage }}
        </div>
      }
    </div>
    <ces-dialog-footer
      [submitLabel]="(hasRenamedElements() ? 'common.buttons.update' : 'common.buttons.validate') | transloco"
      [submitTooltip]="hasRenamedElements() ? ('entities.choiceList.tooltips.listInUseInfo' | transloco) : ''"
      [submitDisabled]="isFormInvalid()"
      (onSubmit)="processSubmit()"
      (onCancel)="cancel()">
      @if (mode === 'edit' && entity && entityDefinition && canShowDeleteButton()) {
        <ces-delete-button
          footer-start
          [label]="entityDefinition.messages.buttons.delete(entity.name) | transloco"
          [disabled]="!canDeleteEntity()"
          [confirmationConfig]="deleteConfig()"
          [pTooltip]="canDeleteEntityMessages()"
          tooltipPosition="bottom"
          (confirm)="deleteEntityAndClose()" />
      }
    </ces-dialog-footer>
  </div>
</form>
